import { getDefaultWallets, RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { configureChains, createConfig, WagmiConfig } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { publicProvider } from 'wagmi/providers/public';

function App(props) {

  var inside = props.inside;
  var currencyID = props.currencyID;
  var chainsIn = props.chains;


  var chainSetOut = chainsIn.filter((aChain, index)=>{
    return currencyID === 0 || currencyID === -1 || aChain.ci === currencyID
  }).map((aChain, index)=>{
    // console.log(aChain);
    return {"id":aChain.ci,"name":aChain.c,"network":aChain.network,"nativeCurrency":{"decimals":aChain.d,"name":aChain.i,"symbol":aChain.i},"rpcUrls":{"default":{"http":aChain.r},"public":{"http":aChain.r}},"blockExplorers":{"etherscan":{"name":aChain.sN,"url":aChain.b[0]},"default":{"name":aChain.sN,"url":aChain.b[0]}},"contracts":{"multicall3":{"address":aChain.multiAdd,"blockCreated":aChain.multiBlock}}};
  })

  if (chainSetOut.length === 0){
    chainSetOut.push(bsc)
  }

  const { chains, publicClient, webSocketPublicClient } = configureChains(
    chainSetOut,
    [publicProvider()]
  );

  const { connectors } = getDefaultWallets({
    appName: 'Cues',
    projectId: '5117fc7203ae7d90e1941f473786e326',
    chains
  });

  const wagmiConfig = createConfig({
    autoConnect: true,
    connectors,
    publicClient,
    webSocketPublicClient,
  });
  return <WagmiConfig config={wagmiConfig}><RainbowKitProvider chains={chains}> {inside}
    </RainbowKitProvider></WagmiConfig>
}

export default App;